<app-select-items
  [titleVisible]="'components.businessTypes.labels.titleVisible' | translate"
  [titleInvisible]="'components.businessTypes.labels.titleInvisible' | translate"
  [items]="allBusinessTypes$ | async"
  (save)="onSave($event)"
></app-select-items>
